import { useRef } from 'react'
import { useParams } from 'react-router'
import { PageHeader } from '../components/PageHeader'
import { PostCard } from '../components/post/PostCard'
import { useIsDesktop } from '../lib/useIsDesktop'

/** Пост, открытый по прямой ссылке (без ленты под ним): страница внутри приложения. */
export function PostPage() {
  const { id } = useParams()
  const desktop = useIsDesktop()
  const videoRef = useRef<HTMLVideoElement | null>(null)
  const postId = Number(id)

  if (desktop) {
    return (
      <>
        <PageHeader title="Пост" />
        <div className="flex h-[max(26rem,calc(100dvh-7rem))] max-w-[1080px] overflow-hidden rounded-2xl bg-card ring-1 ring-line">
          <PostCard id={postId} layout="split" videoRef={videoRef} />
        </div>
      </>
    )
  }
  // Под шапкой приложения и над нижними вкладками: ♥ и «Скачать» под плеером видны сразу.
  return (
    <div>
      <PageHeader title="Пост" />
      <PostCard
        id={postId}
        layout="stack"
        videoRef={videoRef}
        mediaMax="calc(var(--app-height) - var(--safe-top) - var(--mobile-content-bottom) - 7rem - 4.25rem)"
        mediaScrollMargin="calc(var(--safe-top) + 3rem)"
      />
    </div>
  )
}
